import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { fetchClearings } from '../../services/ClearingService';
import { PaginatedData, PaginationConfig } from '../../types/common';
import { NewApiError } from '../../types/NewApiError';
import { Clearing } from '../../types/Clearing';
import { queryKeyFactory } from '../../utils/queryUtils';

export const clearingQueryKeys = queryKeyFactory('clearing');

export function useClearings(
  params: PaginationConfig
): UseQueryResult<PaginatedData<Clearing>, NewApiError> {
  return useQuery({
    queryKey: clearingQueryKeys.list(params),
    queryFn: () => fetchClearings(params),
    enabled: !!params.page,
    keepPreviousData: true,
  });
}
